import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";

const openstackPlanService = {
  getOpenstackPlans:(queries:QueriesApi) => ApiClient.get(`openstack/billing/plan`,{
    params:{
      ...queries,
    }
  }),
  getPlanById:(id:string) => ApiClient.get(`openstack/billing/plan/${id}`),
  createPlan:(data:any) => ApiClient.post(`openstack/billing/plan`, data),
  deletePlanById:(id:string) => ApiClient.delete(`openstack/billing/plan/${id}`),
  updatePlanById:(id:string,data:any) => ApiClient.put(`openstack/billing/plan/${id}`,data),
  setPlanAsDefault:(id:string, name:string) => ApiClient.patch(`openstack/billing/plan/${id}`, {
    name,
    is_default:true,
  }),
  getPlanCreateOptions:() => ApiClient.get(`openstack/billing/plan/create_options`),

  getPriceRuleCreateOptions:() => ApiClient.get(`openstack/billing/pricerule/create_options`),
  createPriceRule:(data:any) => ApiClient.post(`openstack/billing/pricerule`,data),
  getPriceRuleById:(id:string) => ApiClient.get(`openstack/billing/pricerule/${id}`),
  updatePriceRule:(id:string,data:any) => ApiClient.put(`openstack/billing/pricerule/${id}`,data),
  deletePriceRule:(id:string) => ApiClient.delete(`openstack/billing/pricerule/${id}`),
}

export default openstackPlanService
